import {Layout} from '@di-nxt/components';
import React, {useState} from 'react';
import {SideBar} from '../components';
import {Snacks} from '../scenes';
import {TeamsLoader} from '../services';
import {useAuthNavigation, useTeamNavigation} from './hooks';
import {Modals} from './Modals';
import {Scenes} from './Scenes';
import {AppNavigationContext} from './types';

export const AppContainer: React.FC = () => {
  // Track selected team
  const {selectedTeam, setSelectedTeam} = useTeamNavigation();

  // Sidebar visibility
  const [sidebarVisible, setSidebarVisible] = useState<boolean>(false);

  // Navigate to login when auth tokens are empty
  useAuthNavigation();

  return (
    <AppNavigationContext.Provider
      value={{
        selectedTeam,
        setSelectedTeam,
        sidebarVisible,
        setSidebarVisible,
      }}>
      <TeamsLoader />
      <Layout absolute>
        {/* Sidebar */}
        <SideBar />
        <Layout flex>
          {/** Regular screens */}
          <Scenes />
          {/** Modals */}
          <Modals />
        </Layout>
        {/** Snacks **/}
        <Snacks />
      </Layout>
    </AppNavigationContext.Provider>
  );
};
